export default {"src":"/_next/static/image/public/images/post_consult_appointment.a2a08ca544b8576aa29ffd18bd71d569.svg","height":126,"width":121};